import { post } from 'common/utils/xhr';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';

export function handleUpdatedAttribute(ctx, attribute) {
    if (attribute.key === 'genre') {
        return ctx
            .executeAction(updateAttribute, attribute)
            .then(() =>
                ctx.executeAction(unselectAttributes, [
                    'technical_editor',
                    'content_editor',
                    'proof_reader',
                    'indexer',
                ])
            )
            .then(() => ctx.executeAction(calculateAmounts));
    }

    if (attribute.key === 'interior_design_complexity' && attribute.value === 'low') {
        return ctx
            .executeAction(resetInteriorDesignIllustrationCount)
            .then(() => ctx.executeAction(resetInteriorDesignPictureCount))
            .then(() => ctx.executeAction(updateAttribute, attribute))
            .then(() => ctx.executeAction(calculateAmounts));
    }

    return ctx
        .executeAction(updateAttribute, attribute)
        .then(() => ctx.executeAction(calculateAmounts));
}

function resetInteriorDesignIllustrationCount(ctx) {
    return ctx.executeAction(updateAttribute, {
        key: 'interior_design_illustration_count',
        value: 0,
    });
}
function resetInteriorDesignPictureCount(ctx) {
    return ctx.executeAction(updateAttribute, {
        key: 'interior_design_picture_count',
        value: 0,
    });
}

function unselectAttributes(ctx, attributeKeys) {
    return Promise.resolve(ctx.dispatch('UNSELECT_ATTRIBUTES', attributeKeys));
}

function updateAttribute(ctx, attribute) {
    return Promise.resolve(ctx.dispatch('UPDATE_ATTRIBUTE', attribute));
}

function calculateAmounts(ctx) {
    const store = ctx.getStore(BookCalculatorAttributesStore);
    const attributes = store.getState();

    ctx.dispatch('UPDATE_AMOUNTS_STARTED');

    return getAmounts(attributes)
        .then(amounts => ctx.dispatch('UPDATE_AMOUNTS_SUCCESS', amounts))
        .catch(e => ctx.dispatch('UPDATE_AMOUNTS_FAILURE', e));
}

function getAmounts(attributes) {
    const request = post('/book_calculator/xhr/amounts', attributes);

    return new Promise((resolve, reject) => {
        request.end((error, res) => {
            if (error) {
                reject(error);
            } else {
                resolve(res.body);
            }
        });
    });
}
